@if (!useRedesignedCard()) {
  @if (address()) {
    <mwe-tooltip-card
      [cardClass]="tooltipClass()"
      [iconClass]="'fas fa-map-marker-alt'"
      [textNodeType]="textNodeType()"
      [header]="address().addressGroup.groupName"
      [content]="formattedAddress()"
      [hasTooltipBody]="hasTooltipBody() && !hideTooltipBody()"
      [disabled]="isEndedContract()"
      [hasButtons]="shouldDisplayActionComponents()"
    >
      @if (featuredButtons().length) {
        <div slot="buttons" class="col-auto">
          @if (!isEndedContract()) {
            <div class="row align-items-center justify-content-center gx-3">
              @for (item of featuredButtons(); track item.id) {
                <div class="col-auto">
                  <button
                    id="{{ dropdownEditId() + '-option-' + $index }}"
                    [attr.data-test]="dropdownEditId() + '-option-' + item.id"
                    (click)="executeItemAction(item.id)"
                    class="btn btn-sm btn-ghost-outline"
                    [disabled]="disabled()"
                  >
                    {{ item.label | translate }}
                  </button>
                </div>
              }
            </div>
          }
        </div>
      }
      @if (dropdownType() === 'custom') {
        <div slot="dropdown" class="col-auto text-end align-self-center">
          @if (!isEndedContract()) {
            <ng-content select="[slot='icon-right']" />
          }
        </div>
      }
      @if (dropdownType() === 'dropdown' && dropdownItems().length) {
        <div slot="dropdown" class="col-auto text-end align-self-center">
          @if (!isEndedContract()) {
            <div ngbDropdown placement="bottom-right top-right">
              <button
                type="button"
                id="{{ dropdownEditId() }}"
                [attr.data-test]="dropdownEditId()"
                (click)="$event.currentTarget.blur()"
                class="btn btn-sm btn-ghost-outline"
                ngbDropdownToggle
                [ngClass]="{ 'pointer-events-auto': address().addressGroup.detailsLinkType }"
              >
                {{ dropdownEditKey() | translate }}
                <i class="ml-2 fas fa-chevron-down"></i>
              </button>

              <div
                ngbDropdownMenu
                class="dropdown-menu dropdown-menu-right"
                style="background-color: white !important"
                [ngClass]="{ 'pointer-events-auto': address().addressGroup.detailsLinkType }"
              >
                @for (item of dropdownItems(); track $index) {
                  <button
                    id="{{ dropdownEditId() + '-option-' + $index }}"
                    [disabled]="item.disabled"
                    [attr.data-test]="dropdownEditId() + '-option-' + item.id"
                    (click)="executeItemAction(item.id)"
                    ngbDropdownItem
                  >
                    {{ item.label | translate }}
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }
      @if (dropdownType() === 'dots' && dropdownItems().length) {
        <div slot="dropdown" class="col-auto text-end">
          @if (!isEndedContract()) {
            <div ngbDropdown placement="bottom-right top-right">
              <button
                type="button"
                id="{{ dropdownEditId() }}"
                [attr.data-test]="dropdownEditId()"
                (click)="$event.currentTarget.blur()"
                class="btn btn-icon btn-ghost-outline btn-sm"
                ngbDropdownToggle
                [ngClass]="{ 'pointer-events-auto': address().addressGroup.detailsLinkType }"
                [attr.title]="'products.addresGroupItems.label' | translate"
              >
                <i class="fas fa-ellipsis-vertical" aria-hidden="true"></i>
              </button>

              <div
                ngbDropdownMenu
                class="dropdown-menu dropdown-menu-right"
                style="background-color: white !important"
                [ngClass]="{ 'pointer-events-auto': address().addressGroup.detailsLinkType }"
              >
                @for (item of dropdownItems(); track $index) {
                  <button
                    id="{{ dropdownEditId() + '-option-' + $index }}"
                    [disabled]="item.disabled"
                    [attr.data-test]="dropdownEditId() + '-option-' + item.id"
                    (click)="executeItemAction(item.id)"
                    ngbDropdownItem
                  >
                    {{ item.label | translate }}
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }
      @if (hasTooltipBody() && !hideTooltipBody()) {
        <div slot="tooltip-body" class="card-basic-body" data-test="mwe-address-details-body">
          @if (!isEndedContract()) {
            <div class="row">
              @if (address().addressGroup.detailsLinkType === detailsLinkTypeEnum.RELOCATION && isAddressDetailsBodyVisible()) {
                <mwe-infobox
                  messageKey="products.address.relocationInProgress"
                  ctaLabelKey="products.address.relocationDetailsLink"
                  ctaWrapperClass="text-start"
                  (onCTAClick)="executeItemAction(detailsLinkItemKey())"
                />
              }
              @if (address().addressGroup.detailsLinkType === detailsLinkTypeEnum.RELOCATION_ERROR && isAddressDetailsBodyVisible()) {
                <mwe-infobox
                  type="danger"
                  messageKey="products.address.relocationError"
                  ctaLabelKey="products.address.relocationDetailsLink"
                  ctaWrapperClass="text-start"
                  (onCTAClick)="executeItemAction(detailsLinkItemKey())"
                />
              }
              @if (address().addressGroup.detailsLinkType === detailsLinkTypeEnum.MOVEOUT && isAddressDetailsBodyVisible()) {
                <mwe-infobox
                  messageKey="products.address.moveOutInProgress"
                  ctaLabelKey="products.address.moveOutDetailsLink"
                  ctaWrapperClass="text-start"
                  (onCTAClick)="executeItemAction(detailsLinkItemKey())"
                />
              }
              @if (address().addressGroup.detailsLinkType === detailsLinkTypeEnum.MOVEOUT_IGNORE_ERROR && isAddressDetailsBodyVisible()) {
                <mwe-infobox
                  messageKey="products.address.moveOutErrorInProgress"
                  type="danger"
                  ctaLabelKey="products.address.moveOutDetailsLink"
                  ctaWrapperClass="text-start"
                  (onCTAClick)="executeItemAction(detailsLinkItemKey())"
                />
              }
              @if (orderDateFormatted()?.length > 0) {
                <mwe-infobox
                  [messageKey]="recentOrderMsgKey()"
                  [textParams]="{ orderDate: orderDateFormatted() }"
                  ctaLabelKey="products.address.detailsLink"
                  ctaWrapperClass="text-start"
                  (onCTAClick)="executeItemAction(detailsLinkItemKey())"
                />
              }
            </div>
          }
        </div>
      }
    </mwe-tooltip-card>
  }
}

@if (useRedesignedCard()) {
  <mwe-selection-card [header]="address().addressGroup.groupName" [content]="formattedAddress()" />
}
